"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const services_1 = require("@/helpers/services");
const modals_1 = require("@/modals");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ManageProgramDetail = ({ program, match, getProgram, deleteProgram, deleteSection, pendingProgram, pendingProgramDelete, }) => {
    const { programId } = match.params;
    React.useEffect(() => {
        if (programId) {
            getProgram(programId);
        }
    }, [programId]);
    if (pendingProgram) {
        return React.createElement(components_1.ScreenLoader, null);
    }
    const onCancel = () => {
        getProgram(programId);
    };
    return (React.createElement("div", { className: styles_scss_1.default.manageProgramDetail },
        React.createElement(components_1.Meta, { title: constants_1.default.managePrograms.helmetTitle, removeViewport: true }),
        React.createElement(components_1.Paper, { className: styles_scss_1.default.paperContainer },
            React.createElement(components_1.Link, { to: constants_1.Routes.ManagePrograms },
                React.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.manageAccounts.detail.backToPrograms, ariaLabel: constants_1.default.manageAccounts.detail.backToPrograms, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
            (program === null || program === void 0 ? void 0 : program.id) && React.createElement(forms_1.ProgramEditForm, { program: program, onCancel: onCancel, deleteSection: deleteSection }),
            React.createElement(components_1.Button, { className: styles_scss_1.default.deleteButton, variant: "transparent", title: constants_1.default.managePrograms.detail.deleteThisProgram, ariaLabel: constants_1.default.managePrograms.detail.deleteThisProgram, imgUrls: { default: constants_1.Images.trashRed, selected: constants_1.Images.trashRed }, onClick: () => {
                    components_1.modalEvents.setAndRender(modals_1.ModalNames.PROGRAM_DELETE, React.createElement(modals_1.ProgramDeleteModal, { programName: program === null || program === void 0 ? void 0 : program.name, pending: pendingProgramDelete, onDelete: () => {
                            deleteProgram({ id: program === null || program === void 0 ? void 0 : program.id, programName: program === null || program === void 0 ? void 0 : program.name });
                        } }));
                } }))));
};
const stateProps = (state) => ({
    program: selectors_1.default.program.getProgramDetail(state),
    pendingProgram: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getProgramDetail),
    pendingProgramDelete: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.deleteProgramAdmin),
});
const dispatchProps = {
    getProgram: (id) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getProgramDetailPayload({ id })),
    deleteProgram: (data) => radio_dispatch_1.reduxSet.makeLatestRequest.dispatch(api_payloads_1.deleteProgramAdminPayload(data)),
    deleteSection: (data) => radio_dispatch_1.reduxSet.makeLatestRequest.dispatch(api_payloads_1.deleteSectionAdminPayload(data)),
};
exports.default = react_redux_1.connect(stateProps, dispatchProps)(ManageProgramDetail);
